// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"233":"fa599a5b","326":"00d41e96","379":"8d5f9a89","443":"387cb42f","451":"20507de5","567":"304162a2","746":"dc145b24","850":"a771f2f3"}[chunkId] + ".js";
};